<template>
  <section>
    <div class="login-title">
      <img class="title" src="@/assets/top/LASHIC_healthlab_logo.png" width="1880" height="203" loading="lazy"/>
    </div>
      <LoginForm />
  </section>
</template>

<script>
import LoginForm from '@/organisms/LoginForm.vue'
export default {

  components: {
    LoginForm
  },
};
</script>

<style>
.login-title {
  margin-top: 100px;
  margin-bottom: 15%;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/templates/LoginPage.vue